import { render } from "./HospitalsOverlay.vue?vue&type=template&id=8f30c774&scoped=true&lang=pug"
import script from "./HospitalsOverlay.vue?vue&type=script&lang=js"
export * from "./HospitalsOverlay.vue?vue&type=script&lang=js"

import "./HospitalsOverlay.vue?vue&type=style&index=0&id=8f30c774&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f30c774"]])

export default __exports__